var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "ui-autocomplete-suggestion", class: _vm.classes },
    [
      _vm._t("default", function () {
        return [
          _vm.type === "simple"
            ? _c("div", { staticClass: "ui-autocomplete-suggestion__simple" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.suggestion[_vm.keys.label] || _vm.suggestion) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _vm.type === "image"
            ? _c("div", { staticClass: "ui-autocomplete-suggestion__image" }, [
                _c("div", {
                  staticClass: "ui-autocomplete-suggestion__image-object",
                  style: _vm.imageStyle,
                }),
                _c(
                  "div",
                  { staticClass: "ui-autocomplete-suggestion__image-text" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.suggestion[_vm.keys.label]) +
                        "\n      "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }